import React, { useState } from 'react';
import NavItem from '../NavItem';

const DropdownMenu = (props: any) => {
    const [dropdown, setDropdown] = useState(false);

    const { menuItems, handler, showMenu } = props;

    return (
        <>
            <ul
                style={{ display: showMenu }}
                className={dropdown ? 'services-submenu clicked' : 'services-submenu'}
                onClick={handler}
            >
                {menuItems?.map((item: any) => (
                    <li key={item.url}>
                        <NavItem
                            className="submenuItem"
                            to={item.url}
                            label={item.label}
                            onClick={() => setDropdown(false)}
                        />
                    </li>
                ))}
            </ul>
        </>
    );
};

export default DropdownMenu;
